var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"participation-confirm"},[_c('ul',{staticClass:"participation-confirm__list"},_vm._l((_vm.participants),function(participant){return _c('li',{key:participant.playerId,staticClass:"participation-confirm__item"},[_c('ConfirmIcon',{attrs:{"checked":participant.hasCheckedIn}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }